import { resetWidget } from '../../../actions/common';
import { selectTransactionId } from '../../../selectors/checkout';
import { ICloudPaymentsPaymentOptions, ICloudPaymentsWidgetOptions } from '../../../types/cloudPayments';
import { TWidgetResult } from '../../../types/api';
import { TThunkAction } from '../../../types/redux';
import { EPaymentProvider } from '../../../types/redux/paymentMethods';
import { getResultSuccess, getResultFail } from '../../../utils/result';

interface IParams {
  widgetOptions: ICloudPaymentsWidgetOptions;
  paymentOptions: ICloudPaymentsPaymentOptions;
}

export const openCloudPaymentsWidgetThunk =
  (params: IParams): TThunkAction =>
  async (dispatch, getState, context) => {
    const { widgetOptions, paymentOptions } = params;

    const { telemetry, resolveWidgetResult } = context;

    const state = getState();
    const transactionId = selectTransactionId(state);

    telemetry.increment('cloud-payments-widget.init');

    const result = await new Promise((resolve: (value: TWidgetResult) => void) => {
      try {
        const widget = new window.cp.CloudPayments(widgetOptions);

        widget.pay('charge', paymentOptions, {
          onSuccess: () => {
            resolve(
              getResultSuccess({
                paymentId: paymentOptions.invoiceId!,
                provider: EPaymentProvider.CloudPayments,
                transactionId,
              }),
            );
          },
          onFail: () => {
            resolve(getResultFail());
          },
        });
      } catch {
        telemetry.increment('cloud-payments-widget.fail');

        resolve(getResultFail());
      }
    });

    dispatch(resetWidget());

    resolveWidgetResult(result);
  };
